'use client'
import { getCampaignParameters } from '@/components/molecules/CampaignManager'
import { usePageTracking } from '@/hooks'
import { APIProvider } from '@vis.gl/react-google-maps'
import { Section } from 'components/atoms'
import { Form } from 'components/molecules'
import { donationForm } from 'components/molecules/Form/__mocks__/data'
import { useEffect } from 'react'

const googleApiKey = process.env.googleMapsApiKey
const CAMPAIGN_COOKIE_NAME = process.env.cookieName || 'none'
const CAMPAIGN_QUERYPARAMS = process.env.campaignQueryParams || ''
const MAIN_DOMAIN = process.env.mainDomain || 'none'

export default function Page({ searchParams }) {
  usePageTracking('donation_form')

  const { formConfig, formFields } = structuredClone(donationForm) ?? {
    formConfig: {},
    formFields: [],
  }

  useEffect(() => {
    localStorage.clear()
  }, [])
  const campaignParams =
    getCampaignParameters(CAMPAIGN_COOKIE_NAME, {}, searchParams) ?? {}
  return (
    <Section className={'donation-form'}>
      <APIProvider apiKey={googleApiKey}>
        <Form
          config={formConfig}
          fields={formFields}
          searchParams={campaignParams}
        />
      </APIProvider>
    </Section>
  )
}
